import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { RootState } from "../../../../store";

import { Application } from "../../../../../../MPP-Common-SPA/utils/generator/applicationModels";
import { FamilyMember } from "../../../../../../MPP-Common-SPA/utils/generator/sectionModels";

interface ApplicationState {
  application: Partial<Application> | null;
  isLoading: boolean;
}

const initialState: ApplicationState = {
  application: null,
  isLoading: false,
};

export const applicationSlice = createSlice({
  name: "application",
  initialState,
  reducers: {
    setApplication: (state, action: PayloadAction<Application>) => {
      state.application = action.payload;
    },
    updateFamilyMember: (
      state,
      action: PayloadAction<{ index: number; member: FamilyMember }>
    ) => {
      if (
        state.application?.applicationData?.applicationData.stepData
          .FamilyMembers?.familyMembers
      ) {
        const updatedFamilyMembers = [
          ...state.application.applicationData.applicationData.stepData
            .FamilyMembers.familyMembers,
        ];
        updatedFamilyMembers[action.payload.index] = action.payload.member;

        state.application = {
          ...state.application,
          applicationData: {
            ...state.application.applicationData!,
            applicationData: {
              ...state.application.applicationData!.applicationData,
              stepData: {
                ...state.application.applicationData!.applicationData.stepData,
                FamilyMembers: {
                  ...state.application.applicationData!.applicationData.stepData
                    .FamilyMembers!,
                  familyMembers: updatedFamilyMembers,
                },
              },
            },
          },
        };
      }
    },
    deleteFamilyMember: (state, action: PayloadAction<number>) => {
      if (
        state.application?.applicationData?.applicationData.stepData
          .FamilyMembers?.familyMembers
      ) {
        const updatedFamilyMembers = [
          ...state.application.applicationData.applicationData.stepData
            .FamilyMembers.familyMembers,
        ];
        updatedFamilyMembers.splice(action.payload, 1);

        state.application = {
          ...state.application,
          applicationData: {
            ...state.application.applicationData!,
            applicationData: {
              ...state.application.applicationData!.applicationData,
              stepData: {
                ...state.application.applicationData!.applicationData.stepData,
                FamilyMembers: {
                  ...state.application.applicationData!.applicationData.stepData
                    .FamilyMembers!,
                  familyMembers: updatedFamilyMembers,
                },
              },
            },
          },
        };
      }
    },
    addFamilyMember: (state, action: PayloadAction<FamilyMember>) => {
      if (state.application) {
        const currentFamilyMembers =
          state.application.applicationData?.applicationData.stepData
            .FamilyMembers?.familyMembers || [];
        const updatedFamilyMembers = [...currentFamilyMembers, action.payload];

        state.application = {
          ...state.application,
          applicationData: {
            ...state.application.applicationData!,
            applicationData: {
              ...state.application.applicationData!.applicationData,
              stepData: {
                ...state.application.applicationData!.applicationData.stepData,
                FamilyMembers: {
                  ...state.application.applicationData!.applicationData.stepData
                    .FamilyMembers!,
                  familyMembers: updatedFamilyMembers,
                },
              },
            },
          },
        };
      }
    },
  },
});

export const {
  setApplication,
  updateFamilyMember,
  deleteFamilyMember,
  addFamilyMember,
} = applicationSlice.actions;

export default applicationSlice.reducer;

export const selectApplication = (state: RootState) =>
  state.application.application;

export const selectFamilyMembers = (state: RootState) =>
  state.application.application?.applicationData?.applicationData.stepData
    .FamilyMembers?.familyMembers || [];
